module.exports = __webpack_public_path__ + "static/media/patrol(28).c4097e43.PNG";